import { RouteItem } from '@eastcoal/router/types/route'

export const memberAuditEnterpriseRoute: RouteItem = {
  title: '企业认证',
  hideInMenu: true,
  children: [
    {
      title: '认证详情',
      path: '/audit/enterprise/detail',
      Component: () => import('./Detail')
    },
    {
      title: '认证审核',
      path: '/audit/enterprise/approve',
      Component: () => import('./Approve')
    }
  ]
}
